import React from "react";
import { type UserFiltersProps } from "utils/types/usersManagement.type";

export default function UserFilters({
  searchValue,
  statusFilter,
  onSearchChange,
  onStatusFilterChange,
}: UserFiltersProps) {
  return (
    <div className="flex items-center gap-4 mb-4">
      <input
        type="text"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search by name or email..."
        className="flex-1 text-black-700 text-sm rounded-lg border border-black-800 focus:outline-0 py-3.5 px-5"
      />
      <select
        value={statusFilter}
        onChange={(e) =>
          onStatusFilterChange(e.target.value as "active" | "inactive" | "all")
        }
        className="text-black-700 text-sm rounded-lg border border-black-800 focus:outline-0 py-3.5 px-5 min-w-[150px]"
      >
        <option value="all">All Status</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>
  );
}

